import { defineStore } from "pinia";
import { ref } from "vue";

export interface PageHeaderStateOptions {
  loading?: boolean;
  goTo?: (event: Event) => void;
}

export const usePageHeaderStore = defineStore("pageHeader", () => {
  const loading = ref(false);
  const goTo = ref<PageHeaderStateOptions["goTo"] | undefined>();

  function set(options: PageHeaderStateOptions = {}) {
    if (options.loading !== undefined) {
      loading.value = options.loading;
    }
    if ("goTo" in options) {
      goTo.value = options.goTo;
    }
  }

  function reset() {
    loading.value = false;
    goTo.value = undefined;
  }

  return { loading, goTo, set, reset };
});
